import React from "react";

const CategoryItemSkeleton = () => {
  return (
    <div className="flex aspect-square min-h-[148px] flex-col items-center justify-center rounded-xl border border-[#B7D4FF] bg-white p-3 shadow-sm select-none">
      <div className="relative flex h-[76px] w-[76px] items-center justify-center rounded-xl bg-white p-2">
        <div className="h-full w-full animate-pulse rounded-lg bg-blue-50" />
      </div>
      <div className="mt-3 w-full">
        <div className="h-3 bg-gray-200 rounded animate-pulse w-3/4 mx-auto" />
        <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2 mx-auto mt-1" />
      </div>
    </div>
  );
};

export default CategoryItemSkeleton;
